import { createApp } from 'vue';
import store from 'shared/store';
import StepByStep from './StepByStep.vue';
import './stepByStepBlock.scss';

const stepByStepContainers = document.querySelectorAll(
	"[data-feature='StepByStep']"
);

stepByStepContainers.forEach((stepByStepContainer) => {
	const app = createApp({
		name: 'StepByStepApp',
	});

	app.component('step-by-step', StepByStep);
	app.use(store);
	app.mount(stepByStepContainer);
});
